module.exports = __webpack_public_path__ + "abe00fb12d591e4ea637037fbcb104c5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-football.png
// module id = 1969
// module chunks = 0